import {
  Box,
  Dialog,
  DialogContent,
  Paper,
  Typography,
  CircularProgress,
  IconButton,
  Button,
  Alert,
  Avatar,
  Chip,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { getEcommercePlaces } from "../../redux/actions/ecommercePlaceActions";
import { getMarketPlaces } from "../../redux/actions/marketplacesActions";
import { useDispatch, useSelector } from "react-redux";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IoMdSave } from "react-icons/io";
import productService from "../../services/productService";
import ecommercePlaceService from "../../services/ecommercePlaceService";
import marketplacesService from "../../services/marketplacesService";
import outWardService from "../../services/outWardService";
import useAlert from "../../hooks/useAlert";
import PropTypes from "prop-types";

const StockAndPriceUpdateModal = ({ open, onClose, productId, categoryId }) => {
  const dispatch = useDispatch();
  const [loadingPleaces, setLoadingPleaces] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [allPlaces, setAllPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [product, setProduct] = useState(null);
  const scrollContainerRef = useRef(null);
  const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
  const [marketpleacesAccounts, setMarketpleacesAllAccounts] = useState([]);
  const { showErrorAlertAll, showSuccessAlertAllNoReload } = useAlert();
  const userId = useSelector((state) => state?.auth?.user?.id);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        setLoadingPleaces(true);
        const [marketResponse, ecommerceResponse] = await Promise.all([
          dispatch(getMarketPlaces()),
          dispatch(getEcommercePlaces()),
        ]);
        const combinedData = [
          ...marketResponse.data.map((item) => ({
            ...item,
            type: "marketplace",
          })),
          ...ecommerceResponse.data.map((item) => ({
            ...item,
            type: "ecommerce",
          })),
        ];
        setAllPlaces(combinedData);
        setLoadingPleaces(false);
      } catch (err) {
        setLoadingPleaces(false);
      }
    };
    fetchPlatforms();
    getProduct();
  }, [dispatch]);

  const handleScroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 300; // Adjust scroll amount as needed
      scrollContainerRef.current.scrollLeft +=
        direction === "left" ? -scrollAmount : scrollAmount;
    }
  };

  const isPlaceSelected = (place) => {
    return selectedPlace?.id === place.id && selectedPlace?.type === place.type;
  };

  const getProduct = async () => {
    try {
      setLoading(true);
      var response = await productService.getProductDetails(
        productId,
        null,
        categoryId
      );
      setProduct(response.data[0]);

      setLoading(false);
    } catch (ex) {
      setLoading(false);
    }
  };

  const createRequestBody = (selectedPlaceName) => {
    const marketPlaceSettings = marketpleacesAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      userId: userId,
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSettings: ecommercePlaceSettings,
      category: product.category,
      productMainId: product.productMainId,
      barcode: product.productBarcodes.filter((k) =>
        selectedPlace.type == "marketplace"
          ? selectedPlace.id == k.marketPlaceId
          : selectedPlace.id == k.ecommercePlaceId
      )[0]?.barcode,
      productPlaceId: product.productPlaces
        .filter((k) =>
          selectedPlace.type == "marketplace"
            ? selectedPlace.id == k.marketPlaceId
            : selectedPlace.id == k.ecommercePlaceId
        )[0]
        ?.ecommerceProductId?.toString(),
      quantity: product.quantity,
      salePrice: product.productPrices.filter((k) =>
        selectedPlace.type == "marketplace"
          ? selectedPlace.id == k.marketPlaceId
          : selectedPlace.id == k.ecommercePlaceId
      )[0]?.salePrice,
      listPrice: product.productPrices.filter((k) =>
        selectedPlace.type == "marketplace"
          ? selectedPlace.id == k.marketPlaceId
          : selectedPlace.id == k.ecommercePlaceId
      )[0]?.listPrice,
      productAttributes: product?.productAttributes,
    };
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await marketplacesService.getMarketPlacesAccountsApi(
          userId
        );
        setMarketpleacesAllAccounts(response?.data?.data?.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Hesap bilgileri alınırken hata oluştu."
        );
      }
    };
    const fetchAccountsEcommerce = async () => {
      try {
        const response =
          await ecommercePlaceService.getEcommercePlaceAccountsApi(userId);
        setEcommerceAllAccounts(response?.data?.data?.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Hesap bilgileri alınırken hata oluştu."
        );
      }
    };
    fetchAccounts();
    fetchAccountsEcommerce();
  }, [userId]);

  const handleSave = async () => {
    try {
      setSaveLoading(true);
      const request = createRequestBody(selectedPlace.name);
      await outWardService.stockAndPrice(
        selectedPlace.name,
        request,
        selectedPlace.type
      );
      setSaveLoading(false);
      showSuccessAlertAllNoReload();
      onClose();
    } catch (exx) {
      setSaveLoading(false);
      showErrorAlertAll();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: {
            xs: "8px",
            sm: "12px",
          },
          overflow: "hidden",
          width: {
            xs: "95%",
            sm: "90%",
            md: "80%",
          },
          margin: {
            xs: "10px",
            sm: "20px",
            md: "32px",
          },
        },
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: { xs: 1, sm: 2 },
          px: { xs: 1, sm: 2 },
          mt: { xs: 3, sm: 5 },
        }}
      >
        <Box
          sx={{
            padding: { xs: 1.5, sm: 2 },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: { xs: 2, sm: 3 },
            backgroundColor: "#fff",
            borderRadius: { xs: 1, sm: 2 },
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                width: { xs: 3, sm: 4 },
                height: { xs: 20, sm: 24 },
                backgroundColor: "#b71c1c",
                mr: { xs: 0.5, sm: 1 },
              }}
            />
            <Typography
              variant="h6"
              color="black"
              sx={{
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                fontSize: {
                  xs: "1rem",
                  sm: "1.25rem",
                  md: "1.5rem",
                },
              }}
            >
              Stok Ve Fiyat Güncelle
            </Typography>
          </Box>
        </Box>
      </Typography>

      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={{ xs: "150px", sm: "200px" }}
        >
          <CircularProgress
            sx={{
              width: { xs: "24px !important", sm: "32px !important" },
              height: { xs: "24px !important", sm: "32px !important" },
            }}
          />
        </Box>
      ) : (
        <DialogContent sx={{ p: { xs: 1, sm: 2 } }}>
          {loadingPleaces ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height={{ xs: "150px", sm: "200px" }}
            >
              <CircularProgress
                sx={{
                  width: { xs: "24px !important", sm: "32px !important" },
                  height: { xs: "24px !important", sm: "32px !important" },
                }}
              />
            </Box>
          ) : (
            <Box sx={{ position: "relative", px: { xs: 2, sm: 6 } }}>
              <IconButton
                onClick={() => handleScroll("left")}
                sx={{
                  position: "absolute",
                  left: { xs: -8, sm: 0 },
                  top: "10%",
                  transform: "translateY(-50%)",
                  bgcolor: "background.paper",
                  boxShadow: 2,
                  "&:hover": { bgcolor: "grey.100" },
                  zIndex: 1,
                  width: { xs: 28, sm: 40 },
                  height: { xs: 28, sm: 40 },
                  "& .MuiSvgIcon-root": {
                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  },
                }}
              >
                <ChevronLeftIcon />
              </IconButton>

              <Box
                ref={scrollContainerRef}
                sx={{
                  display: "flex",
                  overflowX: "auto",
                  pb: { xs: 1, sm: 2 },
                  scrollBehavior: "smooth",
                  "::-webkit-scrollbar": {
                    height: { xs: "4px", sm: "8px" },
                  },
                  "::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "4px",
                  },
                  "::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "4px",
                  },
                  "::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: 1, sm: 2 },
                    p: { xs: 0.5, sm: 1 },
                  }}
                >
                  {allPlaces.map((place) => (
                    <Paper
                      key={`${place.type}-${place.id}`}
                      elevation={isPlaceSelected(place) ? 6 : 2}
                      onClick={() => setSelectedPlace(place)}
                      sx={{
                        p: { xs: 1, sm: 2 },
                        cursor: "pointer",
                        minWidth: { xs: "120px", sm: "140px" },
                        transition: "all 0.2s",
                        transform: isPlaceSelected(place)
                          ? "scale(1.05)"
                          : "scale(1)",
                        border: isPlaceSelected(place)
                          ? `2px solid ${place.colorCode}`
                          : "2px solid transparent",
                        "&:hover": {
                          transform: "scale(1.05)",
                          boxShadow: 3,
                        },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: { xs: 0.5, sm: 1 },
                      }}
                    >
                      <img
                        src={place.iconLink}
                        alt={place.name}
                        referrerPolicy="no-referrer"
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "contain",
                        }}
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "bold",
                          color: place.colorCode,
                          textAlign: "center",
                          fontSize: {
                            xs: "0.75rem",
                            sm: "0.875rem",
                          },
                        }}
                      >
                        {place.name}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              </Box>

              <IconButton
                onClick={() => handleScroll("right")}
                sx={{
                  position: "absolute",
                  right: { xs: -8, sm: 0 },
                  top: "10%",
                  transform: "translateY(-50%)",
                  bgcolor: "background.paper",
                  boxShadow: 2,
                  "&:hover": { bgcolor: "grey.100" },
                  zIndex: 1,
                  width: { xs: 28, sm: 40 },
                  height: { xs: 28, sm: 40 },
                  "& .MuiSvgIcon-root": {
                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  },
                }}
              >
                <ChevronRightIcon />
              </IconButton>

              <Box
                display="flex"
                alignItems="center"
                gap={{ xs: 1, sm: 2 }}
                p={{ xs: 1.5, sm: 2 }}
                sx={{
                  backgroundColor: "background.paper",
                  borderRadius: { xs: 1, sm: 2 },
                  boxShadow: 1,
                  mt: { xs: 2, sm: 3 },
                }}
              >
                <Avatar
                  variant="rounded"
                  src={product?.productImages?.[0]?.imageUrl}
                  slotProps={{ img: { referrerPolicy: "no-referrer" } }}
                  sx={{
                    width: { xs: 48, sm: 56 },
                    height: { xs: 48, sm: 56 },
                  }}
                />
                <Box flexGrow={1}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{
                      fontSize: {
                        xs: "0.875rem",
                        sm: "1rem",
                      },
                    }}
                  >
                    {product?.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: {
                        xs: "0.75rem",
                        sm: "0.875rem",
                      },
                    }}
                  >
                    {product?.brand.name} | {product?.category?.name}
                  </Typography>
                </Box>
              </Box>

              <Alert
                sx={{
                  mt: { xs: 1.5, sm: 2 },
                  "& .MuiAlert-message": {
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",
                    },
                  },
                }}
                severity="info"
              >
                Seçilen pazaryerindeki ürünün stok ve fiyat bilgisi güncellenir.
              </Alert>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: { xs: 3, sm: 5 },
                }}
              >
                <Button
                  onClick={handleSave}
                  variant="contained"
                  disabled={selectedPlace == null}
                  sx={{
                    borderRadius: 2,
                    backgroundColor: "#1F1B45",
                    color: "#FFFFFF",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",
                    },
                    padding: {
                      xs: "8px 16px",
                      sm: "10px 20px",
                    },
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    "&:hover": {
                      backgroundColor: "#2C285A",
                    },
                    mt: { xs: 0.5, sm: 1 },
                    mb: { xs: 1, sm: 2 },
                  }}
                >
                  Seçilen pazaryerinde güncelleme yap
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
      )}
    </Dialog>
  );
};

StockAndPriceUpdateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  productId: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
};

export default StockAndPriceUpdateModal;
